import * as api from './team-dashboard.api';
import * as types from './team-dashboard.types';
import * as queries from './team-dashboard.queries';
import * as mutations from './team-dashboard.mutations';

export * from './team-dashboard.api';
export * from './team-dashboard.types';
export * from './team-dashboard.queries';
export * from './team-dashboard.mutations';

export default {
  ...api,
  ...types,
  ...queries,
  ...mutations
};
